const playPauseButton = document.getElementById('player');
const audio = document.getElementById('origins-audio');

playPauseButton.addEventListener('click', function() {
    if (audio.paused) {
        audio.volume = 0;
        audio.play();
        fadeVolumeIn(audio, 0.5); // Adjust the fade-in duration (in seconds) as needed
    } else {
        fadeVolumeOut(audio, 0.5); // Adjust the fade-out duration (in seconds) as needed
        setTimeout(function() {
            audio.pause();
        }, 500); // Adjust the timeout duration to match the fade-out duration
    }
});

function fadeVolumeIn(audioElement, duration) {
    const fadeInterval = 10; // Milliseconds
    const step = 1 / (duration * 1000 / fadeInterval);
    let volume = 0;
    const fade = setInterval(function() {
        if (volume < 1) {
            volume += step;
            if (volume > 1) {
                volume = 1; // Ensure volume is within the valid range
            }
            audioElement.volume = volume;
        } else {
            clearInterval(fade);
        }
    }, fadeInterval);
}

function fadeVolumeOut(audioElement, duration) {
    const fadeInterval = 10; // Milliseconds
    const step = 1 / (duration * 1000 / fadeInterval);
    let volume = 1;
    const fade = setInterval(function() {
        if (volume > 0) {
            volume -= step;
            if (volume < 0) {
                volume = 0; // Ensure volume is within the valid range
            }
            audioElement.volume = volume;
        } else {
            clearInterval(fade);
        }
    }, fadeInterval);
}